// Text as the printed invoice shows it.

/**
 * Names and descriptions often arrive with the Arabic yeh and kaf («شركت فراورده هاي»), which a
 * Persian font draws with dots under the final yeh. They are shown with the Persian letters; codes
 * and numbers are never passed through here.
 */
export const persianText = (value: string | null | undefined): string =>
  (value || '').replace(/ي/g, 'ی').replace(/ك/g, 'ک').replace(/ى/g, 'ی')

/** Whether a code holds Latin letters (a tax ID, a passport, a currency code) and needs the Latin font. */
export const hasLatinLetters = (value: string | null | undefined): boolean =>
  /[A-Za-z]/.test(value || '')
